// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/InstagramAccounts_ListaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /instagram/accounts/lista
 *
 * Returns the list of Instagram accounts (from the upstream
 * instagram-messaging-service) enriched with local franchise associations.
 */
import type { InstagramAccounts_AccountRow } from './InstagramAccounts_AccountRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type InstagramAccounts_ListaResponseDados = InstagramAccounts_AccountRow[];

export type InstagramAccounts_ListaResponse = ApiResponse<InstagramAccounts_ListaResponseDados>;

registerResponseContract('InstagramAccounts_ListaResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      instagram_account_id: { type: 'number',  required: true },
      ig_user_id:           { type: 'string',  required: true },
      ig_username:          { type: 'string',  required: true },
      page_id:              { type: 'string',  required: false },
      page_name:            { type: 'string',  required: false },
      token_expires_at:     { type: 'string',  required: false },
      active:               { type: 'boolean', required: true },
      franquias_nomes:      { type: 'string',  required: false },
      franquia_ids:         { type: 'array',   required: false },
    },
  },
})
